import { put, call } from 'redux-saga/effects';
/*
 * Since sagas "pull" actions and our API "pushes" actions,
 * we need to create some middle ground in the form of an
 * iterator.
 */

export function createActionEmitter() {
  const actionsInQueue = [];
  const actionsToResolve = [];

  return {
    emit(action) {
      if (actionsToResolve.length) {
        const nextResolve = actionsToResolve.shift();
        nextResolve(action);
      } else {
        actionsInQueue.push(action);
      }
    },

    nextAction() {
      return actionsInQueue.length ?
        Promise.resolve(actionsInQueue.shift()) :
        new Promise((resolve) => actionsToResolve.push(resolve));
    },
  };
}

export function buildWatchEmitter(emitter) {
  return function* watchEmitter() {
    let message = yield call(emitter.nextAction);
    while (message) {
      yield put(message);
      message = yield call(emitter.nextAction);
    }
  };
}

const emitter = createActionEmitter();

export function dispatch(action) {
  /* istanbul ignore next */
  emitter.emit(action);
}

export function initialize(sagaMiddleware) {
  sagaMiddleware.run(buildWatchEmitter(emitter));
}

/* eslint-disable */
export function dispatchPromise(action) {
  //TODO: This!!!!
}
